/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Observable } from 'rxjs';
import { Txn } from '@src/app/model/txn';
import { IFormAction, ActionColor } from '@src/app/shared/form/form.component';
import { FormConfig } from '@src/app/shared/form/FormConfig';
import { PurchaseService } from '@src/app/modules/txn/purchase.service';

export class UnApproveForPaymentAction implements IFormAction {
    name = $localize`Remove Approval`;
    color: ActionColor = 'accent';
    show = false;
    icon = 'thumb_down';
    approvalNeeded = true;
    approvalText = $localize`Remove the approval to pay this invoice`;
    txn: Txn;

    action(txn: Txn, config: FormConfig): Observable<Txn> {
        return (config.service as PurchaseService).unapprove(this.txn);
    }

    setup(txn: Txn) {
        this.txn = txn;
        this.show = (txn.refNr > 0 && txn.approvedAt > 0);
    }
}
